<div *ngIf="data && data.datasets && data.datasets.length > 0">
    <p-chart #chart type="bar" [data]="data" width="800px" height="600px" [responsive]="false"></p-chart>
</div>

